"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaginatedList = void 0;
var React = require("react");
var mobx_react_1 = require("mobx-react");
var typestyle_1 = require("typestyle");
var PaginatedList = (function (_super) {
    __extends(PaginatedList, _super);
    function PaginatedList(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            page: 1
        };
        return _this;
    }
    PaginatedList.prototype.changePage = function (pageNumber) {
        this.setState({ page: pageNumber });
    };
    PaginatedList.prototype.render = function () {
        var _this = this;
        var props = this.props;
        var state = this.state;
        var elementCount = props.children.length;
        var pageCount = Math.ceil(elementCount / props.pageSize);
        var startIndex = (state.page - 1) * props.pageSize;
        var endIndex = startIndex + props.pageSize;
        var children = props.children.slice(startIndex, endIndex);
        var paginator = [];
        var _loop_1 = function (i) {
            paginator.push(React.createElement(Paginator, { key: i, page: i, active: i == state.page, onClick: function () { return _this.changePage(i); } }));
        };
        for (var i = 1; i <= pageCount; i++) {
            _loop_1(i);
        }
        var format = gettext("Showing page %s of %s (%s items)");
        var data = [state.page, pageCount, elementCount];
        var text = interpolate(format, data);
        return React.createElement("div", null,
            React.createElement("div", null, children),
            React.createElement("nav", { "aria-label": "pagination" },
                React.createElement("ul", { className: "pagination" }, paginator)),
            React.createElement("div", null, text));
    };
    PaginatedList = __decorate([
        mobx_react_1.observer
    ], PaginatedList);
    return PaginatedList;
}(React.Component));
exports.PaginatedList = PaginatedList;
var Paginator = (function (_super) {
    __extends(Paginator, _super);
    function Paginator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Paginator.prototype.render = function () {
        var props = this.props;
        var activeModifier = props.active ? "active" : "";
        return React.createElement("li", { className: (0, typestyle_1.classes)("page-item", activeModifier), onClick: props.onClick },
            React.createElement("a", { href: "#0", className: "page-link" }, props.page));
    };
    Paginator = __decorate([
        mobx_react_1.observer
    ], Paginator);
    return Paginator;
}(React.Component));
